import React from 'react';
import { CNavLink } from '../CNavLink';
import { useActiveLeague } from '../../hooks/useActiveLeague';
import TutorialTooltip from '../common/TutorialTooltip';

function LeaguePageNav() {
  const { activeLeague } = useActiveLeague();

  if (activeLeague?.gameMode === 'quickplay') {
    return null;
  }

  return (
      <div className="onpage-nav-block">
          <ul className="onpage-nav">
                <TutorialTooltip
                  id="league-nav-tooltip"
                  title="League page"
                  description="Here you can view the league table and upcoming matches. To view match information, go to the Fixtures page."
                  className="f-right"
                />

              <CNavLink to={activeLeague ? `/${activeLeague.slug}/fixtures` : '#'} active={['fixtures']}>
                  Fixtures
              </CNavLink>
              <CNavLink to={activeLeague ? `/${activeLeague.slug}/table` : '#'} active={['table']}>
                  Table
              </CNavLink>
              <CNavLink to={activeLeague ? `/${activeLeague.slug}/totw` : '#'} active={['totw']}>
                  TOTW
              </CNavLink>
          </ul>

      </div>
  )
}

export {LeaguePageNav}
